import React from 'react';
import { FinancesDollarIcon } from './finances-dollar-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import financesPersonImage from './finances-person.webp';

interface FinancesTopicCardProps {
  title: string;
  className?: string;
}

export const FinancesTopicCard: React.FC<FinancesTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-2 top-3 h-[52px] w-[52px] shrink-0 sm:left-5 sm:top-4 sm:h-[78.425px] sm:w-[78.609px]">
          <FinancesDollarIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={financesPersonImage}
          alt=""
          className="relative z-10 ml-6 aspect-[107/123] w-[87px] shrink-0 object-cover object-top sm:ml-11 sm:w-[130.485px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
